<template>
  <div>
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
    >
      <template v-slot:header-title>
        Configurações
      </template>

      <v-row>
        <v-col cols="5">
          <v-treeview
            :open.sync="openedDirectories"
            :items="configsList"
            item-key="path"
            dense
            hoverable
            class="py-4"
          >
            <template v-slot:label="{ item }">
              <div
                class="tree-item"
                :class="{
                  'tree-item--selected':
                    selectedFile &&
                    selectedFile.path === item.path
                }"
                style="cursor: pointer;"
                @click.stop="handleClick(item)"
              >
                <v-icon
                  class="pr-2"
                  size="18"
                >
                  {{ item.type == 'directory' ? 'mdi-folder-outline' : 'mdi-file-document-outline' }}
                </v-icon>
                {{ item.filename || parseNameDirectory(item.path) }}
                <BaseMenuOptions
                  :menu-itens="menuItens"
                  :item-data="item"
                  size="x-small"
                  class="mx-2"
                  @onClick="setSelectedFile(item)"
                />
              </div>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical />

        <v-col cols="7">
          <div
            v-if="selectedFile"
            class="py-4 px-2"
          >
            <div class="app-align-items-center">
              <span class="body-2">
                <strong>Arquivo:</strong> {{ selectedFile.path }}
              </span>

              <v-spacer />
              <BaseButton
                type="text"
                color="blueff"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                @click="enableEditFile()"
              >
                {{ readOnly ? 'Editar arquivo' : 'Cancelar' }}
              </BaseButton>
              <BaseButton
                v-if="!readOnly"
                type="text"
                color="blueff"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                @click="saveEditFile()"
              >
                Salvar
              </BaseButton>
            </div>
            <BaseCodemirror
              ref="cm-file-config"
              v-model="selectedFile.fileContent"
              cm-ref="cm-file-config"
              title="Visualização prévia"
              :cm-height="600"
              :lang="cmMode"
              :read-only="readOnly"
            />
          </div>
          <div
            v-else
            class="empty-state"
          >
            <img
              src="@/assets/no-file-select.svg"
              width="200"
            >
            <p class="mt-4 grey--text text--darken-1">
              Nenhum arquivo selecionado
            </p>
          </div>
        </v-col>
      </v-row>

      <BaseSnackbar
        :active-snackbar="feedback"
        :type-snackbar="feedbackColor"
        :text-snackbar="feedbackMessage"
        @closeSnackbar="feedback = !feedback"
      />
    </BaseCard>
    <v-dialog
      v-model="isModalActive"
      persistent
      max-width="560"
    >
      <BaseModal
        :show-indeterminate-progress="modalConfig.showIndeterminateProgress"
        :top-slot-content-title="modalConfig.topSlotContentTitle"
        :remove-button-close="modalConfig.removeButtonClose"
        :middle-slot-content-text-highlight="modalConfig.middleSlotContentTextHighlight"
        :middle-slot-content-text="modalConfig.middleSlotContentText"
        :is-middle-slot-content-text-centered="false"
        :bottom-buttons-align="modalConfig.bottomButtonsAlign"
        :bottom-slot-content-button-cancel-label="modalConfig.bottomSlotContentButtonCancelLabel"
        :bottom-slot-content-button-confirm-label="modalConfig.bottomSlotContentButtonConfirmLabel"
        :remove-button-cancel="modalConfig.removeButtonCancel"
        :remove-button-confirm="modalConfig.removeButtonConfirm"
        @on-cancel="onCancelModal()"
        @on-confirm="onConfirmModal()"
      >
        <p>Tem certeza que deseja carregar um arquivo no caminho abaixo?</p>
        <p
          v-if="selectedFolder"
          class="app-align-items-center my-4 pa-1"
          :style="{ 'background-color': 'var(--v-grayf5-base)' }"
        >
          <v-icon class="mr-2">
            mdi-folder-arrow-up-outline
          </v-icon>
          {{ selectedFolder.path }}
        </p>
        <p class="text-center ma-4">
          Upload de arquivo
        </p>
        <BaseDragAndDrop
          :upload-configuration="uploadConfig"
          :upload-path="uploadPath"
          @onUpload="onUpload"
        />
      </BaseModal>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import BaseMenuOptions from '../../BaseMenuOptions'
import BaseModal from '../../BaseModal'
import BaseDragAndDrop from '../../BaseDragAndDrop'
import BaseCodemirror from '../../BaseCodemirror'
import UtilsCodemirror from '../../../mixins/UtilsCodemirror';

export default {
  components: { BaseSnackbar, BaseMenuOptions, BaseModal, BaseDragAndDrop, BaseCodemirror },
  mixins: [ BaseSnackbarConfiguration, UtilsCodemirror ],
  props: {
    configParameter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      treeDirectory: [],
      openedDirectories: [],
      selectedFile: null,
      selectedFolder: null,
      uploadPath: null,
      isModalActive: false,
      readOnly: true,
      cmMode: null,
      modalConfig: {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Carregar arquivo",
        removeButtonClose: false,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        middleCheckAgree: null,
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Carregar",
        removeButtonCancel: false,
        removeButtonConfirm: false
      },
      uploadConfig: {
        deletable: true,
        multiple: false,
      }
    }
  },
  computed: {
    ...mapState({
      configsList: state => state.common.configsList
    }),
    menuItens() {
      return [
        {
          text: "Carregar",
          icon: "mdi-upload",
          execute: (item) => {
            this.selectedFolder = item
            this.isModalActive = true
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return item.type !== "directory"
          }
        },
        {
          text: this.configParameter ? "Inserir" : "Copiar path",
          icon: this.configParameter ? "mdi-content-paste" : "mdi-content-copy",
          execute: async (item) => {
            if(this.configParameter) {
              this.$emit('onInsertPath', item.path)
            } else {
              await navigator.clipboard.writeText(`config://${item.path}`)
            }
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return item.type == "directory"
          }
        },
        {
          text: "Criar",
          icon: "mdi-plus-box",
          tooltipText: "Em breve",
          execute: (item) => {
          },
          disableButton(item) {
            return true
          },
          hideButton(item){
            return item.type !== "directory"
          }
        },
        {
          text: "Editar",
          icon: "mdi-pencil",
          execute: (item) => {
            this.enableEditFile()
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return item.type == "directory"
          }
        },
        {
          text: "Apagar",
          icon: "mdi-delete",
          tooltipText: "Em breve",
          execute: (item) => {
          },
          disableButton(item) {
            return true
          },
          hideButton(item){
            return item.type == "directory"
          }
        }
      ]
    }
  },
  async created(){
    this.getMutantConfig()
  },
  methods: {
    ...mapActions(['apiMutantConfig', 'apiGetMutantConfigFile', 'apiUploadMutantConfig']),
    async handleClick(item) {
      this.setSelectedFile(item)
      const isOpenDirectory = this.openedDirectories.includes(item.path)

      if (isOpenDirectory) {
        this.openedDirectories = this.openedDirectories.filter(path => path !== item.path)
      }

      try {
        if (!isOpenDirectory && item.type === 'directory') {
          const children = await this.apiMutantConfig(item)
          this.$set(item, 'children', children)
          this.openedDirectories = [
            ...this.openedDirectories,
            item.path
          ]
        }
      } catch (error) {
        this.showFeedback({
          message: 'Erro ao carregar diretório',
          color: 'error'
        })
      }
    },
    async setSelectedFile(item){
      this.readOnly = true
      if (item.type === 'file') {
        try {
          let result = await this.apiGetMutantConfigFile(item.path)
          this.selectedFile = {
            ...item,
            fileContent: this.stringifyValue(result)
          }
          this.cmMode = this.selectedFile.filename.split('.').reverse()[0]
        } catch (error) {
          this.showFeedback({
            message: 'Erro para visualizar arquivo',
            color: 'error'
          })
        }
      } else {
        this.selectedFile = null
      }
    },
    onCancelModal(){
      this.isModalActive = false
      this.uploadPath = null
      this.selectedFolder = null
    },
    onConfirmModal(){
      this.uploadPath = this.selectedFolder.path
    },
    async getMutantConfig(){
      this.openedDirectories = []
      await this.apiMutantConfig()
    },
    async onUpload(value, msg = null){
      let message = `${value ? 'Sucesso ' : 'Erro '} ao carregar arquivo.`
      if(value) {
        this.getMutantConfig()
      }
      this.onCancelModal()
      this.showFeedback({
        message: msg || message,
        color: value ? 'success' : 'error'
      })
    },
    enableEditFile(){
      if(!this.readOnly){
        this.setCodemirrorValue('cm-file-config', this.copyOfSelectedFile.fileContent)
      } else {
        this.copyOfSelectedFile = { ...this.selectedFile }
      }
      this.readOnly = !this.readOnly
    },
    async saveEditFile(){
      try {
        let payload = {
          "path": this.copyOfSelectedFile.path,
          "content": this.encodeByte(this.selectedFile.fileContent)
        }
        await this.apiUploadMutantConfig(payload)
        this.getMutantConfig()
        this.showFeedback({
          message: 'Sucesso ao editar arquivo.',
          color: 'success'
        })
        this.readOnly = true
      } catch (error) {
        this.showFeedback({
          message: 'Erro ao editar arquivo. Tente novamente.',
          color: 'error'
        })
      }
    },
    parseNameDirectory(path){
      return path.split('/').reverse()[0]
    }
  }
}
</script>

<style scoped>
.empty-state {
  height: 100%;
  min-height: 400px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tree-item {
  padding: 4px 8px;
  border-radius: 6px;
  transition: .2s;
}

.tree-item--selected {
  background: #40756d1f;
  color: var(--v-primary-base);
  font-weight: 600;
}
</style>
